export function createHmac() {
  throw new Error('Not implemented');
}

export function timingSafeEqual() {
  throw new Error('Not implemented');
}
